import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import Img from "gatsby-image"
import { getDaysDifference } from '../../services/time-diff';
const BlogList = ({category}) => {
    const data = useStaticQuery(graphql`
        query {
            allContentfulBlogPost (
                sort: {
                  fields:publishedDate,
                  order: DESC
                }
              ){
                edges {
                  node {
                    author {
                        authorName
                        profilePicture {
                            description
                            file {
                              url
                            }
                        }
                    }
                    backgroundImage { 
                      file {
                        url
                      }
                    }
                    title
                    slug
                    seoTags
                    blurb {
                        blurb
                    }
                    categories {
                      categoryName
                      categorySlug
                    }
                    publishedDate
                  }
                }
              }
        }
    `)
    let blogPostsData = data.allContentfulBlogPost.edges;
    if (category) {
      blogPostsData = blogPostsData.filter(edge => edge.node.categories.map(c => c.categoryName).includes(category))
    }
    return <section className="section-blog">
      <div className="row">
        {
          blogPostsData?.length > 0 ? blogPostsData.map((edge, i) => {
          const categories = edge.node.categories;
          return (<div key={i} className="col-1-of-2">
              <article className="blog-card-1">
                <figure>
                  <img
                    src={edge.node.backgroundImage?.file?.url}
                    alt={edge.node.title}
                  />
                </figure>
                <section className="blog-content">
                  <div className="blog-content__category">
                    { categories?.map((c, j) => {
                      return (
                        <React.Fragment  key={j}>
                          { categories.length > 1 && j === categories.length -1 ? '& ': null }
                          <Link to={`/category/${c.categorySlug}`} className="blog-content__category-name">{ c.categoryName }</Link>
                          { categories.length > 0 && j !== categories.length -1 ? ', ': null }
                        </React.Fragment>
                      )
                    })}
                  </div>
                  <h2 className="blog-content__title">
                    <Link to={`/${edge.node.slug}`}>{edge.node.title}</Link>
                  </h2>
                  <p>{edge.node.blurb?.blurb}</p>
                </section>
                <footer>
                  <div className="blog-contentFooter">
                    <img
                      src={edge.node.author?.profilePicture?.file?.url}
                      alt={edge.node.author?.profilePicture?.description}
                    />
                    <span itemProp="author">
                      {edge.node.author?.authorName}
                    </span>
                  </div>
                  <time itemProp="datePublished">
                    {getDaysDifference(edge.node.publishedDate)}
                  </time>
                </footer>
              </article>
            </div>
          )
        }) : <h3>No Articles in this category yet. Please come back later.</h3>
      }
      </div>
    </section>
}


export default BlogList

